import React from 'react'

const ChatSectionSkeleton = () => {
    const chatSectionStyle = {
        backgroundColor: '#fafaff',
        maxWidth: '500px',
        minWidth: '200px',
        width: '38%',
        padding: '28px 39px',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 'inset 0px -1px 0px rgba(53, 49, 106, 0.2)',
        borderRadius: '16px',
        marginBottom: '20px',
        marginRight: '37px',
    }

    const searchInputHolderStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '17px',
        marginTop: '33px',
    }

    const searchInputStyle = {
        width: '100%',
        height: '56px',
        borderRadius: '8px',
        backgroundColor: '#e5e5f0',
        border: 'none',
    }

    const skeletonItemStyle = {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '16px',
        padding: '25px 22px',
        cursor: 'default',
        opacity: 0.5,
    }

    const skeletonIconCircleStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '50%',
        width: '50px',
        height: '50px',
        background: '#e0e0e0',
    }

    const skeletonDetailsStyle = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
    }

    const skeletonTextLine = (width) => ({
        height: '16px',
        backgroundColor: '#e5e5f0',
        borderRadius: '4px',
        width: width,
    })

    return (
        <div style={chatSectionStyle}>
            <div className="animate-pulse" style={searchInputHolderStyle}>
                <div style={searchInputStyle}></div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 12, marginTop: 5 }}>
                <div className="animate-pulse" style={{ height: 25, backgroundColor: '#e5e5f0', borderRadius: 4, width: 55, marginRight: 30 }} />
                {[...Array(3)].map((_, i) => (
                    <div
                        className="animate-pulse"
                        key={i}
                        style={{
                            height: 40,
                            width: 80,
                            borderRadius: 10,
                            backgroundColor: '#e5e5f0',
                        }}
                    />
                ))}
            </div>

            <div className="chat-list scrollbar-none">
                {Array.from({ length: 6 }).map((_, idx) => (
                    <div style={skeletonItemStyle} key={idx}>
                        <div className="chat-icon">
                            <div className="animate-pulse" style={skeletonIconCircleStyle} />
                        </div>
                        <div style={skeletonDetailsStyle}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="animate-pulse" style={skeletonTextLine('40%')} />
                                <div className="animate-pulse" style={skeletonTextLine('10%')} />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div className="animate-pulse" style={skeletonTextLine('30%')} />
                                <div className="animate-pulse" style={skeletonTextLine('20%')} />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default ChatSectionSkeleton
